/**
 * Copyright 2014-present Palantir Technologies
 * @license MIT
 */
"use strict";
var Animator;
(function (Animator) {
    Animator.MAIN = "main";
    Animator.RESET = "reset";
})(Animator = exports.Animator || (exports.Animator = {}));



//////////////////
// WEBPACK FOOTER
// ./~/plottable/build/src/plots/commons.js
// module id = 434
// module chunks = 0